module.exports = __webpack_public_path__ + "75aadc3c749aee0fb18520074a6018a9.png";